import React, { useState, useEffect } from "react";
import "./AboutUsSec1.css";

import { Swiper, SwiperSlide } from "swiper/react";
import { Pagination, Autoplay } from "swiper/modules";

import "swiper/css";
import "swiper/css/pagination";

const destinations = [
  {
    name: "Vietnam",
    image: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/mission/Our%20Destination%20Partner%20Network/vietnam.webp",
  },
  {
    name: "Maldives",
    image: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/mission/Our%20Destination%20Partner%20Network/maldives.webp",
  },
  {
    name: "Singapore",
    image: "https://blueberrydatastorage.blob.core.windows.net/websitesdata/Dmc/New-DMC/mission/Our%20Destination%20Partner%20Network/singapore.webp",
  },
];

const AboutUsSec1 = () => {
  const [isTablet, setIsTablet] = useState(false);

  useEffect(() => {
    const checkScreen = () => setIsTablet(window.innerWidth <= 1024);
    checkScreen();

    window.addEventListener("resize", checkScreen);
    return () => window.removeEventListener("resize", checkScreen);
  }, []);

  return (
    <div className="destinations-container standard-padding">
      <h1 className="heading destinations-heading">
        Our Destination Partner Network
      </h1>

      {isTablet ? (
        <Swiper
          modules={[Pagination, Autoplay]}
          spaceBetween={16}
          slidesPerView={3}
          autoplay={{ delay: 2000, disableOnInteraction: false }}
          pagination={{ clickable: true }}
          breakpoints={{
            0: { slidesPerView: 1 },
            600: { slidesPerView: 2 },
            900: { slidesPerView: 3 },
          }}
        >
          {destinations.map((item, index) => (
            <SwiperSlide key={index}>
              <div className="destination-card">
                <img src={item.image} alt={item.name} />
                <div className="destination-name">{item.name}</div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      ) : (
        <div className="destinations-grid">
          {destinations.map((item, index) => (
            <div key={index} className="destination-card">
              <img src={item.image} alt={item.name} />
              <div className="destination-name">{item.name}</div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default AboutUsSec1;